// Styles for Dropdown go here.
import { toRem, baseVariables } from '@marriott/mi-ui-library';

import styled from 'styled-components';

export const StyledDropdown = styled.div`
  select {
    width: 100%;
    padding: 1rem 2rem 1rem 1rem !important;
    font-size: 1rem;
    line-height: 1rem;
    border-radius: 0.25rem;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 1rem;
    background-color: transparent;
    color: ${baseVariables.color['base10']};
    border: none;
    outline: ${toRem(1)} solid ${baseVariables.color['bvyBase10']};
    &:focus {
      border: none;
      outline: ${toRem(2)} solid ${baseVariables.color['bvyBase10']};
      outline-color: ${baseVariables.color['base10']};
    }
    &.is-error {
      outline-color: var(--t-form-error-color);
    }
  }

  .error-text {
    color: var(--t-form-error-color);
  }
`;
